/** Theme-aware Scanbrix mark (public/logo-dark.png, public/logo-light.png). */
export default function BrandLogo({ className = "logo-mark", width = 40, height = 40, alt = "Scanbrix" }) {
  const base = process.env.PUBLIC_URL || "";
  return (
    <>
      <img
        src={`${base}/logo-dark.png`}
        alt={alt}
        className={`${className} logo-mark--dark`}
        width={width}
        height={height}
        decoding="async"
      />
      <img
        src={`${base}/logo-light.png`}
        alt=""
        aria-hidden
        className={`${className} logo-mark--light`}
        width={width}
        height={height}
        decoding="async"
      />
    </>
  );
}
